import { defineMessages } from '@faceup/localization'

export const messages = defineMessages('followUp.components.reportSummary.messages', [
  { id: 'title', defaultMessage: '' },
  { id: 'reportId', defaultMessage: '' },
  { id: 'status', defaultMessage: '' },
  { id: 'reported', defaultMessage: '' },
  { id: 'lastAction', defaultMessage: '' },
  { id: 'senderIdentity', defaultMessage: '' },
  { id: 'anonymous', defaultMessage: '' },
  { id: 'sentInformation', defaultMessage: '' },
  { id: 'victimName', defaultMessage: '' },
  { id: 'category', defaultMessage: '' },
  { id: 'moreInfo', defaultMessage: '' },
  { id: 'attachments', defaultMessage: '' },
  { id: 'organizationalUnit', defaultMessage: '' },
  { id: 'classRoom', defaultMessage: '' },
] as const)
